/// #if _DEBUG
//*
import gui, { init } from './tweakpane'
init()
/*/ 
/// #else
import gui from "./dummy";
/// #endif
//*/

export default gui
